'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes", "menuItems"];
import tinymce from 'tinymce';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import TransparentButton from 'rich-text-lib/components/style-protected/StyleProtectedTransparentButton';
import { getFetchProperties, getFetchSiteSettings, getFetchOwners } from 'tinymce-data/api/Properties';
import { getFetchPaths } from 'tinymce-data/api/DataTokens';
import { getHandleProperties } from 'rich-text-lib/utils/buildProperties';
import Routes from 'ContentUtils/Routes';
import { HS_PERSONALIZE } from '../constants/plugins';
import { CANVAS_PERSONALIZE } from '../constants/toolbar';
import { getHandleInsert, getHandleUpdate, getTokenRemoveHandler } from './handlers';
import { isEditableToken } from '../utils/token';
import { i18nWithNameSpace } from '../utils/i18n';
import PersonalizePopoverManager from '../components/PersonalizePopoverManager';
import DataTokenTooltipManager from '../components/DataTokenTooltipManager';
import { getPickerComponent } from '../utils/settings';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = i18nWithNameSpace('TinymcePlugins.hspersonalize');
export const addControls = (editor, pluginName, personalizeConfig, useAsUpgradePoint) => {
  if (useAsUpgradePoint) {
    const PersonalizationUpgradeButton = getPickerComponent(editor, 'PersonalizationUpgradeButton', '`PersonalizationUpgradeButton` codesplit component is required for the personalization upgrade point');
    tinymce.canvas.addButton(editor, CANVAS_PERSONALIZE, {
      renderControl: () => {
        return /*#__PURE__*/_jsx(PersonalizationUpgradeButton, {
          children: i18nKey('button')
        });
      }
    });
    return;
  }
  const {
    apiClient
  } = editor.settings;
  const fetchProperties = getFetchProperties(apiClient);
  const fetchPaths = getFetchPaths(apiClient, personalizeConfig);
  const browserProps = {
    personalizeConfig,
    dropdownClassName: 'mce-hubspot-menu',
    fetchProperties: getHandleProperties(fetchProperties, false, personalizeConfig),
    fetchPaths,
    fetchSiteSettings: getFetchSiteSettings(apiClient),
    fetchOwners: getFetchOwners(apiClient),
    emailSettingsLink: `${editor.settings.appUrl}${Routes.settings('email', 'personalization')}`,
    publishingSettingsLink: `${editor.settings.appUrl}${Routes.settings('publishing')}/all-domains/personalization`
  };
  const handleInsertToken = getHandleInsert(editor, pluginName);
  const handleEditToken = getHandleUpdate(editor, pluginName);
  const handleClick = ({
    isActive
  }) => {
    if (!isActive) {
      editor.fire('OpenPersonalizePopover');
    }
  };
  const isActiveHandler = ({
    element
  }) => {
    if (!element) return false;
    return isEditableToken(editor, element);
  };
  tinymce.canvas.addButton(editor, CANVAS_PERSONALIZE, {
    renderControl: props => {
      const rest = _objectWithoutPropertiesLoose(props, _excluded);
      return /*#__PURE__*/_jsx(UITooltip, {
        title: i18nKey(`tooltip.insert`),
        placement: "bottom",
        children: /*#__PURE__*/_jsx(TransparentButton, Object.assign({
          "data-test-id": "insert-personalization-button",
          use: "transparent",
          onClick: () => {
            handleClick({
              isActive: isActiveHandler({
                element: editor.selection.getNode()
              })
            });
          }
        }, rest, {
          children: i18nKey('button')
        }))
      });
    }
  });
  const isActiveNodeHandler = ({
    element
  }) => {
    if (!element) return false;
    return isEditableToken(editor, element) && element;
  };
  tinymce.canvas.addNodeChangeHandler(editor, {
    eventKey: pluginName,
    includeInlineTargets: true,
    isActiveNodeHandler
  });
  tinymce.canvas.addPopover(editor, HS_PERSONALIZE, {
    renderPopover(renderProps) {
      return /*#__PURE__*/_jsx(PersonalizePopoverManager, Object.assign({
        editor: editor,
        onInsert: handleInsertToken,
        onEdit: handleEditToken,
        eventKey: pluginName,
        onTokenRemove: getTokenRemoveHandler(editor)
      }, browserProps, renderProps));
    }
  });
  tinymce.canvas.addPopover(editor, `${HS_PERSONALIZE}-tooltip`, {
    renderPopover() {
      return /*#__PURE__*/_jsx(DataTokenTooltipManager, {
        editor: editor
      });
    }
  });
};